export const errorConstants = {
    //error name
    ERROR_COMPONENT: 'ERROR_COMPONENT',
    
    //error events types
    SET_ERROR: 'SET_ERROR',
    SET_ERROR_API : 'SET_ERROR_API'
};